<header class="fixed-top bg-black text-white">
  <div class="container p-0">
    <div class="row justify-content-between align-items-center py-2 ps-3 pe-3 pt-3 pb-3">
      <div class="col-auto">
          <a href="https://www.nrc.gov/reading-rm/adams.html"> 
            <!-- style="height:50px!important;" -->
            <img src="assets/nrc-logo-white.webp" class="img-fluid forMobile" style="display: none!important;" alt="US NRC Adams Search Home" />
            <div class="nrc-logo-clip">
              <img src="assets/nrc-logo-white.webp" class="img-fluid notMobile nrc-logo-img" alt="US NRC Home" />
            </div>
          </a>
      </div>
      <div class="col d-flex justify-content-center">
        <a href="#">
          <img src="assets/adams-pub-logo.png" class="img-fluid forMobile" style="height:30px!important;" alt="ADAMS Public Search" />
          <img src="assets/adams-pub-logo.png" class="img-fluid notMobile" style="height:50px!important;" alt="ADAMS Public Search" />
        </a>
      </div>
    </div> 
    <!-- Navigation Bar -->
     <div class="container-fluid nav-bar-bg" style="width:100%;"><app-nav-top></app-nav-top></div>
  </div>
</header>
  <div style="width: 100%; position: relative;">      
    <!-- <button pButton (click)="openFeedback()" class="btn-primary float-end" style="transform: rotate(-90deg);left: 37px;top: 100px;z-index: 9999;"><i class="fa-regular fa-comment me-2"></i>Feedback</button> -->
  </div><app-feedback></app-feedback>
<div class="w-100 m-auto">
  <main role="main" class="px-4 pb-5">
    <app-loader></app-loader>
    <router-outlet>
    </router-outlet>
  </main>
  
</div>

<footer class="bg-tertiary text-dark text-sm p-2">
  <div class="d-flex justify-content-center text-align-center" style="text-align: center;">The ADAMS Public Search enables users to access and search publicly<br>available official agency records within the ADAMS repository.<br>&copy; Nuclear Regulatory Commission 1999-{{currentYear}}</div>
  <div class="me-3 d-flex justify-content-end text-align-end">Index Last Updated: <app-last-updated [lastUpdatedSetting]="lastIndexUpdate"></app-last-updated></div>  
</footer>
